import React from "react";
import styled from "styled-components";
import Banner from "../../Components/Banner";
import { Table, TableCell } from "../../Components/InformationTable";
import { ListContainer, ListItem } from "../../Components/PageComponents";

const PageContainer = styled.div`
    padding: 2em;
    display:flex;
    justify-content: center;
`;
const Content = styled.div`
    width: 60%;
        @media (max-width: 900px) {
            width: 80%;
        }
`;
const SubHeader = styled.p`
    padding-top: 1em;
    font-size: 1rem;
    font-family: Poppins-SemiBold;
    color: var(--main-grey-color);
`;
const BodyText = styled.p`
    font-size: 0.8rem;
    line-height: 1.5em;
`;
const Link = styled.a`
    color: var(--main-teal-color);
    font-family: Poppins-SemiBold;
`;
function UseOfCookiesPage() {

    return (
        <>
            <Banner mainText="Use of Cookies" />
            <PageContainer>
                <Content>
                    <BodyText>Cookies are small text files that are stored on your computer’s hard drive by websites you visit to enable the site to ’remember’ who you are. In general, cookies are only visible to the site that serves them, not to other websites. ‘Serves’ means places on your computer’s hard drive.</BodyText>

                    <SubHeader>The Cookies we use</SubHeader>
                    <BodyText>We use the cookies on this website to help you navigate our website efficiently, perform certain functions and to collect site statistics. These cookies do not store any personal information that would, on its own, allow us to identify individual users of this service without your permission.</BodyText>

                    <BodyText>The Northumbria Healthcare NHS Trust use a number of suppliers (3rd Party) who also set cookies on this website on our behalf, in order to deliver the services that they are providing. If you would like more information about the cookies used by these suppliers, as well as information on how to opt-out, please see the information in the tables provided below.</BodyText>
                    <BodyText>Please be aware that restricting cookies may impact on the functionality of the Northumbria Healthcare NHS Trust website and could mean that key features do not work properly. We strongly recommend allowing cookies from this website so that we can provide you with a full service.</BodyText>
                    <BodyText>To help you make an informed decision, we have categorised the cookies used on this site into two categories;</BodyText>

                    <ListContainer>
                        <ListItem>Necessary cookies – these cookies are fundamental to ensure the site works correctly.</ListItem>
                        <ListItem>Optional cookies – These cookies could help us track how you use the website so that we can improve the information and experience provided to you. They may also provide additional features by 3rd party providers to allow you to socially share content or comment on this website.</ListItem>
                    </ListContainer>

                    <BodyText>The cookies used on this site are explained in the tables below.</BodyText>
                    <Table>
                        <thead>
                            <tr>
                                <TableCell>Provider</TableCell>
                                <TableCell>Cookie</TableCell>
                                <TableCell>Expires</TableCell>
                                <TableCell>Description/Purpose</TableCell>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <TableCell>Northumbria Healthcare NHS Trust</TableCell>
                                <TableCell>Account details</TableCell>
                                <TableCell>Expires</TableCell>
                                <TableCell>This session cookie is used to store details about the employee that has logged in. If you do not allow this cookie this website will not work correctly.</TableCell>
                            </tr>
                        </tbody>
                    </Table>

                    <SubHeader>Optional cookies</SubHeader>
                    <Table>
                        <thead>
                            <tr>
                                <TableCell>Provider</TableCell>
                                <TableCell>Description/Purpose</TableCell>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <TableCell>Google Analytics</TableCell>
                                <TableCell>These cookies are used to collect information about how visitors use our site. We use the information to compile reports and to help us improve the site. The cookies collect information in an anonymous form, including the number of visitors to the site, where visitors have come to the site from and the pages they visited. We use this Plug-in to allow us to provide a better user experience to you and only use it on the basis that Google adheres to its own Privacy Policy.
                                    <Link href="/http://www.google.com/intl/en/privacypolicy.html">The Google Privacy policy</Link>
                                </TableCell>
                            </tr>
                        </tbody>
                    </Table>

                    <SubHeader>How to control and remove cookies</SubHeader>
                    <BodyText>The Northumbria Healthcare NHS Trust will not use cookies to collect personally identifiable information about you unless you willing provide it. However, if you wish to restrict or block the cookies which are set by this website, or indeed any other website, you can do this through your browser settings. The Help function within your browser should tell you how.</BodyText>
                    <BodyText>Alternatively, you may wish to visit <Link href="https://allaboutcookies.org/"> www.aboutcookies.org</Link>  which contains comprehensive information on how to do this on a wide variety of browsers. You will also find details on how to delete cookies from your computer as well as more general information about cookies.</BodyText>
                    <BodyText>For information on how to do this on the browser of your mobile phone you will need to refer to your handset manual.</BodyText>
                    <BodyText>We do not use ’spyware’, that is web bugs or hidden identifiers or other similar devices to gain access to information, store hidden information or to trace your activities.</BodyText>

                    <SubHeader>Traffic data</SubHeader>
                    <BodyText>We keep a record of traffic data which is logged automatically by the server. This includes your IP address, the website address you visited before ours, the website address you visit after leaving our site and which pages you visit on our site. We do not store or analyse this traffic data in a way that identifies any individual. We also use Google Analytics for site statistics – see 'Cookies’ above for details of how this works.</BodyText>
                </Content>
            </PageContainer>
        </>
    );
}
export default UseOfCookiesPage;